import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const HoldingIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 8C18 8 21 9.79 21 12C21 14.21 18 16 18 16M6 16C6 16 3 14.21 3 12C3 9.79 6 8 6 8M8 14V10C8 8.895 8.895 8 10 8H14C15.105 8 16 8.895 16 10V14C16 15.105 15.105 16 14 16H10C8.895 16 8 15.105 8 14Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

HoldingIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(HoldingIcon);
